import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Place } from '../../../appointments/models/appointment.model';
import { NgxPaginationConfig } from '@shared/models/ngx-pagination-config';
import { Utilities } from '@shared/utilities/utilities.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'amd-cc-center-list-for-appointment',
	templateUrl: './cc-center-list-for-appointment.component.html',
	styleUrls: ['./cc-center-list-for-appointment.component.scss']
})

export class CcCenterListForAppointmentComponent {
    static CENTER_CLASS_DEFAULT = 'amd-link amd-link--border amd-link--station';
    static CENTER_CLASS_SELECTED = 'amd-link amd-link--border amd-link--station amd-link--active';

    @Input() places: Place[];
    @Input() sectionExpertHidden = false;
		@Output() activateCenterEventEmitter: EventEmitter<Place> = new EventEmitter<Place>();

		previousCenter: Place;

    paginator: NgxPaginationConfig = {
			itemsPerPage : 10,
			autoHide : true,
			previousLabel : '',
			nextLabel : '',
			screenReaderPageLabel : 'Paginazione',
			screenReaderCurrentLabel : 'Pagina',
			maxSize: 100
		};
	mapItemsClasses: Map<string, string> = null;
	translateContext = TranslateContext;
	form: FormGroup;
	formFields: typeof EFormFields = EFormFields;
	displayPlaces: Place[] = [];

	constructor(public fb: FormBuilder) { }

	private initializeClasses() {

		this.displayPlaces = this.places;
		this.mapItemsClasses = new Map<string, string>();
		for (let  i = 0 ; i < this.displayPlaces.length ; i++) {
			this.mapItemsClasses.set(this.displayPlaces[i].place_id , CcCenterListForAppointmentComponent.CENTER_CLASS_DEFAULT);
		}
	}

	ngOnInit() {
		this.form = this.getFormGroup();
	}

	ngOnChanges() {
		if (this.places) {
			this.initializeClasses();
		}
	}
	
	private getFormGroup(): FormGroup {
		return this.fb.group({
			[EFormFields.ID]   :[],
			[EFormFields.NAME] :[],
		});
	}

	selectedCenter(center: Place) {

		if (this.previousCenter !== center) {
			this.mapItemsClasses.set(center.place_id, CcCenterListForAppointmentComponent.CENTER_CLASS_SELECTED);
			if (!Utilities.isVoid(this.previousCenter)) {
				this.mapItemsClasses.set(this.previousCenter.place_id, CcCenterListForAppointmentComponent.CENTER_CLASS_DEFAULT);
			}
			this.activateCenterEventEmitter.emit(center);
		}
		this.previousCenter = center;
	}
	
	filterPlaces() {
		try {

			this.displayPlaces = ((x, y) => {

				if (!x && !y)	return this.places;				

				[x, y] = [x, y].map(x => x ? x.trim().toLowerCase() : '');
				return this.places.filter(o => o.ald_commodity_id.toString().startsWith(x) && o.name.toLowerCase().includes(y));

			})(this.form.controls[EFormFields.ID].value, this.form.controls[EFormFields.NAME].value);		

		} catch(e) {
			console.error(e);
		}
	}
}

enum EFormFields {
	ID   = 'id',
	NAME = 'name',
}